
import baseURL from "../common/axios";
class CustomerContactDetailsService {
    insert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("CustomerContactDetails/Create", objinsert);
    }
    getdata() {
        debugger;
        return baseURL.httpMSInventoryUrl.get("CustomerContactDetails/List");
    }
    Edit(EditID) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "CustomerContactDetails/Get?id=" + EditID + ""
        );
    }
    Delete(DelID) {
        debugger;
        return baseURL.httpMSInventoryUrl.delete(
            "CustomerContactDetails/Delete?id=" + DelID
        );
    }
    //Active
    active(DelID, Status) {
        debugger;
        return baseURL.httpMSInventoryUrl.put(
            "CustomerContactDetails/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
    Update(objupdate) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("CustomerContactDetails/Update", objupdate);
    }

    //FileInsert
    Fileinsert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post(
            "ManufactureImagesMAS/Create",
            objinsert
        );
    }

    //Get Files by Manufacture Id
    GetFilesByManufactureId(ManufactureId) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "ManufactureImagesMAS/ListManufactureImagesMASByCustomerContactDetailsId?ManufactureId=" +
            ManufactureId +
            ""
        );
    }
}
export default new CustomerContactDetailsService();
